// extracted by mini-css-extract-plugin
export var aside = "menu-module--aside--iwiF9";
export var center = "menu-module--center--Q5AFK";
export var flex = "menu-module--flex--CZvX+";
export var hideOnDesktop = "menu-module--hideOnDesktop--ANVtt";
export var img = "menu-module--img--dp64l";
export var mM = "menu-module--m-m--WuCuH";
export var mbM = "menu-module--mb-m---lRjB";
export var menu = "menu-module--menu--PtZ5v";
export var menuTitle = "menu-module--menuTitle--G48WE";
export var offer = "menu-module--offer--KFb0U";
export var typeFilter = "menu-module--typeFilter--tk-Ls";
export var wrapper = "menu-module--wrapper--F64qH";